import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import {
  GetPropertiesPayload,
  GetPropertyDetailsPayload,
  IConfirmBooking,
  ICreateOTP,
  IHotelIssue,
  ISendOTP,
  InitiatePropertyBookingType,
} from "@/core/types/hotel";
import { HotelEndPoints } from "@/core/constants/hotels";
import { formatString } from "@/core/utils/helpers";

class HotelService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public get(params: string): Promise<ICoreResponse> {
    return this.restClient.get(
      HotelEndPoints.GET_ALL_LOCATIONS + `?search_query=${params}`,
    );
  }

  public fetchProperties(params: GetPropertiesPayload): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.GET_ALL_PROPERTIES, params);
  }

  public fetchPropertyDetails(
    params: GetPropertyDetailsPayload,
  ): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.GET_PROPERTY_DETAIL, params);
  }

  public fetchBookingDetails(bookingId: string): Promise<ICoreResponse> {
    return this.restClient.get(HotelEndPoints.GET_BOOKING + `${bookingId}/`); //not migrated
  }

  public initiatePropertyBooking(
    params: InitiatePropertyBookingType,
  ): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.INITIATE_BOOKING, params);
  }

  public confirmBooking(params: IConfirmBooking): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.CONFIRM_BOOKING, params);
  }

  public cancelBooking(bookingId: string): Promise<ICoreResponse> {
    return this.restClient.put(
      formatString(HotelEndPoints.CANCEL_BOOKING, bookingId),
    );
  }

  public payForBooking(bookingId: string): Promise<ICoreResponse> {
    return this.restClient.put(
      formatString(HotelEndPoints.PAY_NOW_BOOKING, bookingId),
    );
  }

  public hotelIssue(params: IHotelIssue): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.ISSUE, params);
  }

  public createOtp(params: ICreateOTP): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.CREATE_OTP, params);
  }
  public sendOtp(params: ISendOTP): Promise<ICoreResponse> {
    return this.restClient.post(HotelEndPoints.RESEND_OTP, params);
  }

  public downloadVoucher(bookingId: string): Promise<ICoreResponse> {
    return this.restClient.get(
      `${HotelEndPoints.DOWNLOAD_TICKET}/${bookingId}`,
      {},
      { responseType: "blob" },
    );
  }
}

export default HotelService;
